/* tfp-kauf.js — Gebindewahl und Bildwechsel der Kaufkarte (snippets/tfp-kaufkarte.liquid).
   Angelegt 07.10.2026, Theme-Kopie 193816592759. Preis, Grundpreis und Verfügbarkeit stehen
   je Variante als data-Attribut an der Option (aus Shopify gerendert); hier wird nur umgeschaltet. */
(function () {
  function aktualisieren(select) {
    var karte = select.closest('[data-tkf-karte]');
    if (!karte) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    var preis = karte.querySelector('[data-tkf-preis]');
    var grund = karte.querySelector('[data-tkf-grundpreis]');
    var knopf = karte.querySelector('[data-tkf-knopf]');
    if (preis) preis.textContent = opt.getAttribute('data-preis') || '';
    if (grund) grund.textContent = opt.getAttribute('data-grundpreis') || '';
    if (knopf) {
      var ok = opt.getAttribute('data-verfuegbar') === 'true';
      knopf.disabled = !ok;
      var t = knopf.querySelector('span');
      if (t) t.textContent = ok ? (knopf.getAttribute('data-text-ok') || 'In den Warenkorb') : (knopf.getAttribute('data-text-aus') || 'Ausverkauft');
    }
    var tipp = karte.querySelector('[data-tkf-tipp]');
    if (tipp) {
      var text = opt.getAttribute('data-tipp') || '';
      var ziel = opt.getAttribute('data-tipp-ziel') || '';
      tipp.textContent = '';
      if (text) {
        var el = document.createElement(ziel ? 'button' : 'span');
        if (ziel) { el.type = 'button'; el.className = 'tkf-tipp__knopf'; el.setAttribute('data-tkf-tipp-ziel', ziel); }
        el.textContent = text;
        tipp.appendChild(el);
      }
    }
  }
  function bildwechsel(knopf) {
    var karte = knopf.closest('[data-tkf-karte]');
    var img = karte && karte.querySelector('[data-tkf-bild]');
    if (!img) return;
    var zweit = img.getAttribute('data-tkf-bild-2');
    if (!zweit) return;
    var aktiv = knopf.getAttribute('aria-pressed') === 'true';
    if (!aktiv) {
      img.setAttribute('data-tkf-src-1', img.getAttribute('src') || '');
      img.setAttribute('data-tkf-srcset-1', img.getAttribute('srcset') || '');
      img.removeAttribute('srcset');
      img.setAttribute('src', zweit);
      if (img.getAttribute('data-tkf-alt-2')) img.setAttribute('alt', img.getAttribute('data-tkf-alt-2'));
      karte.classList.add('tkf-karte--foto');
      knopf.setAttribute('aria-pressed', 'true');
      knopf.setAttribute('aria-label', knopf.getAttribute('data-aria-1') || 'Gestaltungsbild anzeigen');
      knopf.textContent = knopf.getAttribute('data-text-1') || '1. Bild';
    } else {
      img.setAttribute('src', img.getAttribute('data-tkf-src-1') || img.getAttribute('src'));
      var ss = img.getAttribute('data-tkf-srcset-1');
      if (ss) img.setAttribute('srcset', ss);
      if (img.getAttribute('data-tkf-alt-1')) img.setAttribute('alt', img.getAttribute('data-tkf-alt-1'));
      karte.classList.remove('tkf-karte--foto');
      knopf.setAttribute('aria-pressed', 'false');
      knopf.setAttribute('aria-label', knopf.getAttribute('data-aria-2') || 'Produktfoto anzeigen');
      knopf.textContent = knopf.getAttribute('data-text-2') || '2. Bild';
    }
  }
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el && el.matches && el.matches('select[data-tkf-variante]')) aktualisieren(el);
  });
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-tkf-bildwechsel]') : null;
    if (el) { e.preventDefault(); bildwechsel(el); return; }
    var tipp = e.target && e.target.closest ? e.target.closest('[data-tkf-tipp-ziel]') : null;
    if (tipp) {
      e.preventDefault();
      var karte = tipp.closest('[data-tkf-karte]');
      var sel = karte && karte.querySelector('select[data-tkf-variante]');
      if (sel) {
        sel.value = tipp.getAttribute('data-tkf-tipp-ziel');
        aktualisieren(sel);
        sel.focus();
      }
    }
  });
  /* Warenkorb-Seitenleiste auf dieser Seite: nur Empfehlungen aus dem Wildvogel-Sortiment zeigen
     (Johann 07.10.: Taubenfutter-Empfehlung vor dem gekauften Artikel war irreführend). Die Empfehlungen
     selbst baut cross-sell.js; hier wird nur gefiltert. Reihenfolge und Abstände: tfp-kauf.css. */
  var sortiment = null;
  try { var j = document.querySelector('[data-tkf-sortiment]'); if (j) sortiment = JSON.parse(j.textContent); } catch (err) {}
  function filtern() {
    if (!sortiment) return;
    document.querySelectorAll('.cs-wrap--drawer').forEach(function (wrap) {
      var karten = wrap.querySelectorAll('[data-cs-card]');
      if (!karten.length) return;
      var sichtbar = 0;
      karten.forEach(function (k) {
        var a = k.querySelector('a[href*="/products/"]');
        var h = a ? a.getAttribute('href').split('/products/')[1].split(/[?#]/)[0] : '';
        var ok = sortiment.indexOf(h) !== -1;
        k.style.display = ok ? '' : 'none';
        if (ok) sichtbar++;
      });
      wrap.classList.toggle('tkf-cs-leer', sichtbar === 0);
    });
  }
  if (sortiment && window.MutationObserver) {
    new MutationObserver(filtern).observe(document.body, { childList: true, subtree: true });
  }
})();
